import GradientCalculatorContainer from './GradientCalculatorContainer';

export default GradientCalculatorContainer;
